import React, { useMemo } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Box, Tab, Tabs, makeStyles } from "@material-ui/core";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import VpnKeyIcon from "@material-ui/icons/VpnKey";

import FlowBuilder from "../FlowBuilder";
import CampaignsPhrase from "../CampaignsPhrase";

const TAB_CONVERSATION = "conversation";
const TAB_CAMPAIGN = "campaign";

const useStyles = makeStyles((theme) => ({
  tabsWrap: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    background:
      theme.palette.type === "dark"
        ? "linear-gradient(180deg, rgba(15, 23, 42, 0.96) 0%, rgba(15, 23, 42, 0.88) 100%)"
        : "linear-gradient(180deg, rgba(248, 250, 252, 0.96) 0%, rgba(241, 245, 249, 0.88) 100%)",
    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.08)",
    paddingTop: 8,
    paddingBottom: 8
  },
  tabsRoot: {
    minHeight: 54
  },
  tabsIndicator: {
    height: 4,
    borderRadius: 999
  },
  tabRoot: {
    minHeight: 50,
    fontWeight: 500,
    textTransform: "none",
    fontSize: "0.84rem",
    borderRadius: 12,
    marginRight: 10,
    transition: "all .18s ease",
    border: `1px solid ${theme.palette.divider}`,
    background:
      theme.palette.type === "dark"
        ? "rgba(15, 23, 42, 0.82)"
        : "rgba(255, 255, 255, 0.85)"
  },
  tabWrapper: {
    flexDirection: "row",
    gap: 6
  },
  tabSelected: {
    background:
      theme.palette.type === "dark"
        ? "rgba(30, 41, 59, 0.95)"
        : "rgba(255, 255, 255, 0.98)"
  }
}));

const FlowBuilderHub = () => {
  const classes = useStyles();
  const history = useHistory();
  const { tab } = useParams();

  const activeTab = useMemo(() => {
    if (tab === TAB_CAMPAIGN) return TAB_CAMPAIGN;
    if (tab === TAB_CONVERSATION || !tab) return TAB_CONVERSATION;
    return TAB_CONVERSATION;
  }, [tab]);

  const handleChangeTab = (_, nextTab) => {
    history.push(`/flowbuilders/${nextTab}`);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100%"
      width="100%"
      bgcolor="background.default"
    >
      <Box
        px={2}
        pt={1}
        className={classes.tabsWrap}
      >
        <Tabs
          value={activeTab}
          onChange={handleChangeTab}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          classes={{
            root: classes.tabsRoot,
            indicator: classes.tabsIndicator
          }}
        >
          <Tab
            icon={<ChatBubbleOutlineIcon fontSize="small" />}
            label="Fluxo de conversa"
            value={TAB_CONVERSATION}
            classes={{
              root: classes.tabRoot,
              selected: classes.tabSelected,
              wrapper: classes.tabWrapper
            }}
          />
          <Tab
            icon={<VpnKeyIcon fontSize="small" />}
            label="Fluxo por palavra chave"
            value={TAB_CAMPAIGN}
            classes={{
              root: classes.tabRoot,
              selected: classes.tabSelected,
              wrapper: classes.tabWrapper
            }}
          />
        </Tabs>
      </Box>

      <Box flex={1} minHeight={0}>
        {activeTab === TAB_CAMPAIGN ? <CampaignsPhrase /> : <FlowBuilder />}
      </Box>
    </Box>
  );
};

export default FlowBuilderHub;
